import React, { useState, useRef } from "react";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import Care from "./Care";
import { fetchRandomQuote } from "./service/quotesApi";
import SEO from "../components/SEO";

export default function FullBody() {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const toastRef = useRef(null);
  const [currentQuote, setCurrentQuote] = useState("Loading quote...");

  const servicesData = [
    {
      id: 13,
      name: "Full Body 5 Body Parts",
      price: "9,499",
      originalPrice: "10,333",
      duration: "2 Hr 30 Min",
      includes: ["Hands", "Face", "Legs", "Underarms", "Bikini"],
      sessions: 1,
    },
    {
      id: 14,
      name: "Full Body 5 Body Parts",
      price: "25,499",
      originalPrice: "29,997",
      duration: "2 Hr 30 Min",
      includes: ["Hands", "Face", "Legs", "Underarms", "Bikini"],
      sessions: 3,
    },
    {
      id: 15,
      name: "Full Body 5 Body Parts",
      price: "48,499",
      originalPrice: "59,997",
      duration: "2 Hr 30 Min",
      includes: ["Hands", "Face", "Legs", "Underarms", "Bikini"],
      sessions: 6,
    },
    {
      id: 16,
      name: "Full Body 8 Body Parts",
      price: "10,499",
      originalPrice: "13,333",
      duration: "3 Hrs",
      includes: [
        "Hands",
        "Face",
        "Legs",
        "Underarms",
        "Bikini",
        "Chest & Stomach",
        "Back",
        "Buttocks",
      ],
      sessions: 1,
    },
    {
      id: 17,
      name: "Full Body 8 Body Parts",
      price: "28,499",
      originalPrice: "31,497",
      duration: "3 Hrs",
      includes: [
        "Hands",
        "Face",
        "Legs",
        "Underarms",
        "Bikini",
        "Chest & Stomach",
        "Back",
        "Buttocks",
      ],
      sessions: 3,
    },
    {
      id: 18,
      name: "Full Body 8 Body Parts",
      price: "54,499",
      originalPrice: "62,994",
      duration: "3 Hrs",
      includes: [
        "Hands",
        "Face",
        "Legs",
        "Underarms",
        "Bikini",
        "Chest & Stomach",
        "Back",
        "Buttocks",
      ],
      sessions: 6,
    },
  ];

  const handleAddToCart = async (service) => {
    addToCart(service);
    try {
      const quoteData = await fetchRandomQuote();
      setCurrentQuote(quoteData.fullQuote);
    } catch (error) {
      setCurrentQuote("Looking great!");
    }
    const toast = new window.bootstrap.Toast(toastRef.current);
    toast.show();
  };

  const handleBuyNow = async (service) => {
    addToCart(service);
    try {
      const quoteData = await fetchRandomQuote();
      setCurrentQuote(quoteData.fullQuote);
    } catch (error) {
      setCurrentQuote("Looking great!");
    }
    navigate("/checkout");
  };

  return (
    <div
      className=" min-vh-100"
      style={{ fontFamily: "'Inter', sans-serif", backgroundColor: "#8dcae4" }}
    >
		<SEO
      title="Full Body Laser Hair Reduction in Bangalore | FlawSkin"
      description="Book full body laser hair reduction at home in Bangalore with FlawSkin. Choose from 5 or 8 body-part packages with flexible session options."
      canonical="https://flawskin.com/Fullbody"
    />
      <Navbar />

      <main className="container py-5">
        {/* Main Service Intro Banner */}
        <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5 bg-white mb-3">
          <div className="row align-items-center g-4">
            <div className="col-auto d-none d-sm-block">
              <div className="p-3 bg-primary-subtle rounded-4 text-primary">
                <img
                  src="assets/assets/img/fullbody.png"
                  alt="Full Body Category Icon"
                  style={{
                    width: "48px",
                    height: "48px",
                    objectFit: "contain",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            </div>
            <div className="col">
              <span className="badge text-bg-primary px-3 py-2 rounded-pill mb-2 small fw-semibold">
                Premium Care
              </span>
              <h1 className="h3 fw-bold text-dark mb-2">Full Body</h1>
              <p
                className="text-secondary mb-0 border-start border-3 ps-3 py-1"
                style={{ fontSize: "15px", maxWidth: "700px" }}
              >
                Experience ultimate smooth, hair-free confidence across your
                full body layout. Safe, clinically proven, and calibrated
                precision diagnostics for long-term results.
              </p>
            </div>
          </div>
        </div>

        {/* Packages Grid Section Title */}
        <div className="d-flex align-items-center justify-content-between mb-1">
          <div>
            <h2 className="h4 fw-bold text-white mb-1">
              Available Treatment Modules
            </h2>
            <p className="text-white small mb-0">
              Select your preferred session depth options
            </p>
          </div>
        </div>

        {/* Packages Grid */}
        <div className="row g-4">
          {servicesData.map((service) => (
            <div className="col-md-6" key={service.id}>
              <div className="card border-light-subtle shadow-sm rounded-3 bg-white p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  {/* Top Heading Group */}
                  <div className="d-flex justify-content-between align-items-start gap-2 mb-3">
                    <h3 className="h6 fw-bold text-dark mb-0 mt-1">
                      {service.name}
                    </h3>
                    <div className="d-flex gap-1 flex-shrink-0">
                      <span className="badge text-bg-light  small text-secondary px-2 py-1 rounded-2">
                        <svg
                          width="20"
                          height="20"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M269.62,436.454H35.557c-9.948,0-18.013,8.065-18.013,18.013c0,9.948,8.065,18.013,18.013,18.013h234.064
				c9.948,0,18.013-8.065,18.013-18.013C287.633,444.519,279.569,436.454,269.62,436.454z"
                                />
                                <path
                                  d="M467.635,413.673l-68.947-0.055L374.5,370.546c6.055,6.36,13.686,11.061,22.331,13.615
				c4.76,1.406,9.615,2.101,14.442,2.101c8.358,0,16.635-2.088,24.182-6.194l15.469-8.415c11.909-6.479,20.581-17.206,24.419-30.206
				c3.839-13,2.385-26.719-4.094-38.626l-8.414-15.467c-6.479-11.909-17.204-20.581-30.205-24.42
				c-13-3.841-26.719-2.387-38.626,4.092l-15.468,8.415c-21.293,11.585-30.971,36.303-24.487,58.686l-2.602-4.634
				c-0.919-1.636-1.971-3.251-3.127-4.806c-7.018-9.874-16.785-17.24-27.852-21.356c0.838-0.773,1.66-1.572,2.448-2.421
				c16.656-17.927,15.624-46.063-2.294-62.727L208.672,133.931c-1.018-0.946-2.112-1.867-3.259-2.744
				c-0.567-0.464-1.159-0.89-1.741-1.332c6.458-1.524,12.612-4.328,18.143-8.342c10.972-7.962,18.185-19.719,20.312-33.106
				l2.764-17.393c4.39-27.635-14.522-53.691-42.157-58.083l-17.392-2.764c-27.63-4.393-53.691,14.521-58.083,42.157l-2.763,17.389
				c-2.127,13.387,1.086,26.803,9.048,37.774c3.999,5.511,8.957,10.071,14.597,13.518c-5.437,1.899-10.627,4.602-15.419,8.079
				c-12.874,9.344-21.339,23.141-23.844,38.91L88.412,299.599H59.554C26.716,299.599,0,326.314,0,359.152
				c0,32.838,26.716,59.554,59.554,59.554l240.152-0.006l34.314,61.106c8.276,14.735,24.409,23.533,41.248,22.584l92.311,0.077
				c0.01,0,0.017,0,0.025,0c24.466,0,44.381-19.898,44.396-44.367C512.016,433.62,492.114,413.691,467.635,413.673z
				 M388.669,315.851c1.113-3.772,3.629-6.883,7.084-8.764l15.469-8.415c3.454-1.88,7.431-2.302,11.205-1.186
				c3.772,1.113,6.883,3.63,8.764,7.085l8.415,15.468c1.879,3.455,2.302,7.434,1.188,11.206c-1.114,3.772-3.629,6.883-7.084,8.763
				l-15.47,8.415c-3.454,1.878-7.434,2.3-11.204,1.188c-3.772-1.114-6.883-3.63-8.765-7.086l-8.415-15.468
				C387.977,323.603,387.555,319.622,388.669,315.851z M160.074,75.368l2.763-17.389c1.275-8.018,8.832-13.505,16.85-12.232
				l17.391,2.764c8.019,1.275,13.506,8.835,12.233,16.851l-2.764,17.393c-0.617,3.882-2.709,7.294-5.891,9.603
				c-3.185,2.31-7.079,3.245-10.961,2.625l-17.391-2.763c-3.884-0.617-7.294-2.709-9.604-5.893S159.456,79.253,160.074,75.368z
				 M144.467,173.588c0.986-6.206,4.329-11.658,9.416-15.349c5.086-3.69,11.302-5.179,17.513-4.196
				c4.177,0.664,8.091,2.435,11.323,5.124c0.238,0.198,0.479,0.389,0.727,0.575c0.268,0.199,0.502,0.394,0.687,0.566L296.07,264.55
				c0.005,0.005,0.011,0.01,0.016,0.014c3.382,3.143,3.577,8.449,0.436,11.831c-3.141,3.383-8.449,3.576-11.803,0.461
				l-70.183-65.454c-4.883-4.554-11.882-6.032-18.189-3.845c-6.307,2.188-10.886,7.685-11.899,14.284l-11.94,77.759h-47.636
				L144.467,173.588z M256.286,299.599h-47.333l5.929-38.614L256.286,299.599z M467.609,466.441c-0.001,0-0.004,0-0.005,0
				l-92.891-0.077c-0.006,0-0.012,0-0.018,0c-0.443,0-0.886,0.017-1.328,0.049c-3.222,0.241-6.351-1.428-7.934-4.247l-39.476-70.298
				c-3.188-5.679-9.194-9.192-15.706-9.192l-250.697,0.007c-12.974,0-23.529-10.555-23.529-23.529
				c0-12.974,10.555-23.528,23.529-23.528h44.286h84.125H299.76c7.645,0,14.846,3.75,19.263,10.029
				c0.118,0.168,0.238,0.334,0.363,0.497c0.257,0.34,0.476,0.67,0.651,0.983l52.399,93.306c3.186,5.674,9.184,9.188,15.691,9.192
				l79.481,0.065c0,0,0,0,0.001,0c4.617,0.004,8.371,3.761,8.367,8.377C475.971,462.69,472.217,466.441,467.609,466.441z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                        {service.sessions}{" "}
                        {service.sessions === 1 ? "Session" : "Sessions"}
                      </span>
                    </div>
                  </div>

                  {/* Trust Badge Rating */}
                  <div className="d-flex align-items-center gap-2 mb-3 small">
                    <div className="text-warning">
                      <i className="fa fa-star me-1"></i>
                      <span className="fw-bold text-dark">5.0</span>
                    </div>
                    <a
                      href="https://www.google.com/search?hl=en-IN&amp;gl=in&amp;q=Flawskin+pvt+Ltd..."
                      className="text-muted text-decoration-none border-start ps-2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      (234 Verified Reviews)
                    </a>
                  </div>

                  {/* Core Timing Specs */}
                  <div className="d-flex align-items-center gap-2 mb-4 text-secondary small bg-light p-2 rounded-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="currentColor"
                      className="bi bi-clock text-primary"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.433l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                    </svg>
                    <span>
                      Est. Treatment Window: <strong>{service.duration}</strong>{" "}
                      per session
                    </span>
                  </div>

                  {/* Inclusions Group */}
                  <div className="mb-4">
                    <h4
                      className="text-uppercase tracking-wider text-muted fw-bold mb-2"
                      style={{ fontSize: "11px" }}
                    >
                      Areas Covered
                    </h4>
                    <div className="d-flex flex-wrap gap-1.5">
                      {service.includes.map((part, index) => (
                        <span
                          key={index}
                          className="badge bg-light text-dark border border-light-subtle font-medium px-2.5 py-1.5 rounded-2 small fw-normal"
                        >
                          ✓ {part}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Pricing & Checkout Block */}
                <div className="mt-auto pt-3 border-top border-light-subtle">
                  <div className="d-flex align-items-baseline justify-content-between mb-3">
                    <span className="text-muted small">Package Price</span>
                    <div className="text-end">
                      <del className="text-muted small me-2">
                        ₹{service.originalPrice}
                      </del>
                      <span className="h4 fw-bold text-primary mb-0">
                        ₹{service.price}
                      </span>
                    </div>
                  </div>

                  {/* Utility Support Modals Links */}
                  <div className="mb-3">
                    <a
                      href="#"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      className="text-decoration-none small text-secondary d-inline-flex align-items-center gap-1 bg-light px-2.5 py-1 rounded-2 border"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="bi bi-journal-medical text-primary"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5"
                        />
                        <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
                      </svg>
                      Pre & Post Care Directive
                    </a>
                  </div>

                  {/* Primary CTA Elements */}
                  <div className="row g-2">
                    <div className="col-6">
                      <button
                        className="btn btn-outline-primary w-100 py-2 fw-semibold rounded-3 text-uppercase small"
                        style={{ fontSize: "12px", letterSpacing: "0.5px" }}
                        onClick={() => handleAddToCart(service)}
                      >
                        Add to Cart
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="btn btn-primary w-100 py-2 fw-semibold rounded-3 text-uppercase small shadow-sm"
                        style={{ fontSize: "12px", letterSpacing: "0.5px" }}
                        onClick={() => handleBuyNow(service)}
                      >
                        Buy Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      <Care />

      {/* Modern Status Confirmation Toast */}
      <div
        className="toast-container position-fixed bottom-0 end-0 p-3"
        style={{ zIndex: 1055 }}
      >
        <div
          ref={toastRef}
          className="toast border-0 shadow-lg rounded-3 bg-white"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          data-bs-autohide="true"
          data-bs-delay="4000"
        >
          <div className="toast-body p-3">
            <div className="d-flex gap-3 align-items-start">
              <div className="text-success mt-0.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="bi bi-check-circle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
              </div>
              <div className="d-flex flex-column flex-grow-1 gap-1">
                <div className="d-flex align-items-center">
                  <span className="fw-bold text-dark small">
                    Item added to selection
                  </span>
                  <button
                    type="button"
                    className="btn-close btn-close-sm ms-auto"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <p className="mb-0 text-secondary fst-italic small border-start ps-2 mt-1">
                  "{currentQuote}"
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
